import colorsHelper from '../ui/colors'

export default {
    methods: colorsHelper
}
